import { Component, EventEmitter, Output } from '@angular/core';

export type FxRateRowSource = 'closing' | 'average' | 'position';

/**
 * FX (REV-21512): source picker for a rate row — the RATE mirror of
 * `calculation-function-selection`. Emits the picked source; the super table
 * then runs the rate-row flow (confirmation on first row, tree picker for
 * position rates).
 */
@Component({
    selector: 'rate-source-selection',
    templateUrl: './rate-source-selection.component.html',
    styleUrls: ['./rate-source-selection.component.scss'],
})
export class RateSourceSelectionComponent {
    selectedOption: FxRateRowSource | undefined;

    @Output() selectedRateSource: EventEmitter<FxRateRowSource> = new EventEmitter<FxRateRowSource>();

    onSelectedRateSourceChange(source: FxRateRowSource): void {
        this.selectedOption = source;
        this.selectedRateSource.emit(source);
    }
}
